import { api } from "./api";
import { AxiosError, AxiosResponse } from 'axios';
import { AuthBodyType } from "./types";
import { manageType } from "../components/Managements/NewManages";

export type ManagesType = {
  nome: string,
  empresa: string,
  clientes?: string[],
  formularios?: string[],
  gerentes?: string[],
  equipes?: string[],
  dataCriacao: number,
  dataDelecao?: number,
  dataEdicao: number,
  id: string,
  users: string[],
  geral?: boolean
};

class Manages {


  getAllManages = async (body: AuthBodyType) => {
    try {
      const data: AxiosResponse = await api.post("/gerencias/getAll",
        {
          ...body,
        }
      );
      return data.data.gerencias;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  createManage = async (body: AuthBodyType & { nome: string }) => {
    try {
      const data: AxiosResponse = await api.post("/gerencias/create",
        {
          ...body,
        }
      );
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  updateManage = async (body: AuthBodyType & {
    nome?: string,
    formularios?: string[],
    gerentes?: string[],
    equipes?: string[],
    dataDelecao?: number | boolean,
    users?: string[],
    id: string,
    clientes?: string[],
  }) => {
    try {
      const data: AxiosResponse = await api.post("/gerencias/edit",
        {
          ...body,
        }
      );
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  getAll = async (body: AuthBodyType) => {
    try {
      const data: AxiosResponse = await api.post("/gerencias/v2/getAll",
        {
          ...body,
        }
      );
      return data.data.gerencias;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  createV2 = async (body: AuthBodyType, gerencia: manageType) => {
    try {
      const data: AxiosResponse = await api.post("/gerencias/v2/create",
        {
          ...body,
          gerencia

        }
      );
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  editV2 = async (body: AuthBodyType, gerencia: manageType) => {
    try {
      const data: AxiosResponse = await api.post("/gerencias/v2/edit",
        {
          ...body,
          gerencia

        }
      );
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };
}

export default Manages;
